import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { loginReq } from "Requests/User.req";
import sha256 from "sha256";
import userStore from "stores/userStore";

const Login = () => {
  const navigate = useNavigate();
  const user = userStore((state) => state);
  const [idInput, setIdInput] = useState("");
  const [pwInput, setPwInput] = useState("");

  const goBack = () => {
    navigate(-1);
  };

  const tryLogin = async () => {
    try {
      let id = idInput.trim();
      if (id.length === 0) {
        toast.error("아이디를 입력해주세요.");
        return;
      }

      let pw = pwInput.trim();
      if (pw.length === 0) {
        toast.error("비밀번호를 입력해주세요.");
        return;
      }

      const result = await loginReq(id, sha256(sha256(id) + pw));
      const { user: userInfo, token } = result;
      const { nickname, autoGenerated } = userInfo;
      console.log(result);

      user.setUid(userInfo.uid);
      user.setNickname(nickname);
      user.setAutoGenerated(autoGenerated);
      user.setToken(token);

      navigate("/");
    } catch (err) {
      console.error(err);
      toast.error("오류가 발생했습니다.");
    }
  };

  const goToSignupPage = () => {
    navigate("/signup");
  };

  return (
    <div className="login page">
      {/* <div className="mips">MIPS</div> */}
      <div className="label">로그인</div>
      <div className="input-container">
        <input
          className="main-input"
          type="text"
          placeholder="아이디"
          onChange={(e) => setIdInput(e.target.value)}
          value={idInput}
        />
        <input
          className="main-input"
          type="password"
          placeholder="비밀번호"
          onChange={(e) => setPwInput(e.target.value)}
          value={pwInput}
        />
        <div className="sign-up" onClick={goToSignupPage}>
          아직 회원이 아니신가요?
        </div>
      </div>
      <div className="main-btn-container">
        <button className="main-btn highlight" onClick={tryLogin}>
          로그인
        </button>
        <button className="main-btn unhighlight" onClick={goBack}>
          돌아가기
        </button>
      </div>
    </div>
  );
};

export default Login;
